import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfigService, ApplicationId, ErrorReportingService, IUserDetails, LoginBackgroundService, ProviderType, SecurityService } from 'common';
import { Subscription } from 'rxjs';

@Component({
  selector: 'acc-manage',
  templateUrl: './manage-profile.component.html',
  styleUrls: ['./manage-profile.component.scss'],
})
export class ManageProfileComponent implements OnInit, OnDestroy {
  user: IUserDetails;
  showRegisterAccount: boolean = true;
  hasAssociatedAccounts: boolean = false;
  tableData = new MatTableDataSource();
  tableColumns = ['accountCode', 'accountName', 'providerType'];
  subscription = new Subscription();

  pendingAccountRequests: boolean = false;
  tableDataAccountRequests = new MatTableDataSource();
  tableColumnsAccountRequests = ['accountName', 'providerType', 'submissionDate', 'status'];

  constructor(
    private security: SecurityService,
    private errorService: ErrorReportingService,
    private router: Router,
    private route: ActivatedRoute,
    private loginBackground: LoginBackgroundService,
    private env: AppConfigService
  ) {}

  ngOnInit(): void {
    this.user = this.security.profile.user;
    this.tableData.data = this.user.accounts;
    this.showRegisterAccount = this.env.config.applicationId === ApplicationId.eLicensing;
    this.hasAssociatedAccounts = this.security.hasAssociatedAccounts;
    this.tableDataAccountRequests.data = this.route.snapshot.data.pendingAccountRegistrations;
    this.pendingAccountRequests = this.tableDataAccountRequests.data.length > 0;
    this.loginBackground.showLoginBackground = false;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  resetPassword(): void {
    this.subscription.add(
      this.security.requestPasswordReset(this.security.profile.username).subscribe({
        next: (result) => {
          this.errorService.displayInfo('Request sent successfully.');
        },
        error: (_) => this.errorService.displayWarning('There was a problem processing your request.'),
      })
    );
  }

  resetMfa(): void {
    this.subscription.add(
      this.security.requestMfaReset(this.security.profile.username).subscribe({
        next: (result) => {
          this.errorService.displayInfo('Request sent successfully.');
        },
        error: (_) => this.errorService.displayWarning('There was a problem processing your request.'),
      })
    );
  }

  registerAccount(): void {
    this.router.navigate(['accounts/registration']);
  }

  logOut(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.navigateByUrl('/?reason=logout');
  }
}
